import { Injectable } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ErrorAlertComponent } from "../../../ui/components/alerts/error/error.alert.component";
import { ConfirmAlertComponent } from "../../../ui/components/alerts/confirm/confirm.alert.component";

@Injectable({
    providedIn: "root"
})
export class AlertUtils {
    constructor(private modalService: NgbModal) {}

    public showErrorAlert(title: string, message: string): void {
        const modalRef = this.modalService.open(ErrorAlertComponent);
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
    }

    public showConfirmAlert(title: string, message: string, onConfirm: () => unknown, onClose: () => unknown) {
        const modalRef = this.modalService.open(ConfirmAlertComponent, { centered: true });
        modalRef.componentInstance.title = title;
        modalRef.componentInstance.message = message;
        modalRef.result.then(() => {
            onConfirm();
        }, () => {
            onClose();
        });
    }

}
